export default {"src":"/_next/static/media/data_providers.4822a7c0.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};